import React from "react";

import { StringParser } from "./StringParser";

interface OwnProps {
    value: string;
}

const Table = ({ value }: OwnProps) => {
    const rows = value
        .trim()
        .split("\n")
        .map((row) =>
            row
                .split("|")
                .map((cell) => cell.trim())
                .slice(1, -1),
        );

    if (rows.length < 2) return null;

    const header = rows[0];
    const body = rows.slice(2);

    return (
        <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid #ddd", marginTop: "10px" }}>
            <thead>
                <tr>
                    {header.map((th, index) => (
                        <th
                            key={index}
                            style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                                textAlign: "left",
                                backgroundColor: `#F0F0F0`,
                                fontSize: "14px",
                                fontWeight: "700",
                                lineHeight: "140%",
                            }}
                        >
                            {StringParser(th)}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {body.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {row.map((td, cellIndex) => (
                            <td
                                key={cellIndex}
                                style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    lineHeight: "140%",
                                }}
                            >
                                {StringParser(td)}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default Table;
